<div *ngIf="loading" class="d-flex justify-content-center align-items-center my-5 w-100">
  <div class="text-muted">Loading user journeys…</div>
</div>

<div *ngIf="!loading && (!workflows || workflows.length === 0) && !errorMsg" class="d-flex justify-content-center align-items-center my-5 w-100">
  <div class="error-container">
    <div class="error-icon-container">
      <mat-icon class="error-icon">route</mat-icon>
    </div>
    <div class="error-content">
      <h3 class="error-title">No User Journeys</h3>
      <p class="error-description">You haven't created any User Journeys yet.</p>
      <div class="d-flex justify-content-center">
        <button class="btn btn-track mt-2" (click)="navigateToMyAccount()">
          <mat-icon>add</mat-icon>
          <span class="ms-1">Create your first journey</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!errorMsg && workflows.length > 0" class="graph m-5 p-4">


  <mat-form-field appearance="outline" class="mb-3" *ngIf="workflows.length > 1">
    <mat-label>Select a RUM Workflow</mat-label>
    <mat-select [(ngModel)]="selectedWorkflow" (selectionChange)="selectWorkflow($event.value)">
      <mat-option *ngFor="let wf of workflows" [value]="wf">
        {{ wf.name | titlecase }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="selectedWorkflow" class="d-flex justify-content-center align-items-center mb-3">
    <h2>{{ selectedWorkflow.name | titlecase }} - User Journey</h2>
  </div>

  <div class="device-query-switch d-flex justify-content-between align-items-center" *ngIf="workflows && workflows.length > 0">
    <div class="radio-inputs">
      <label class="radio">
        <input
          type="radio"
          name="radioDevice"
          value="desktop"
          [(ngModel)]="selectedDevice"
          (ngModelChange)="onFilterChange($event)"
        />
        <span class="name">Desktop</span>
      </label>
      <label class="radio">
        <input
          type="radio"
          name="radioDevice"
          value="mobile"
          [(ngModel)]="selectedDevice"
          (ngModelChange)="onFilterChange($event)"
        />
        <span class="name">Mobile</span>
      </label>
    </div>
    <div class="radio-inputs">
      <label class="radio">
        <input
          type="radio"
          name="radioInterval"
          value="daily"
          [(ngModel)]="selectedQueryInterval"
          (ngModelChange)="onFilterChange($event)"
        />
        <span class="name">Daily</span>
      </label>
      <label class="radio">
        <input
          type="radio"
          name="radioInterval"
          value="weekly"
          [(ngModel)]="selectedQueryInterval"
          (ngModelChange)="onFilterChange($event)"
        />
        <span class="name">Weekly</span>
      </label>
      <label class="radio">
        <input
          type="radio"
          name="radioInterval"
          value="monthly"
          [(ngModel)]="selectedQueryInterval"
          (ngModelChange)="onFilterChange($event)"
        />
        <span class="name">Monthly</span>
      </label>
    </div>
  </div>

  <div class="chart-header mt-3" *ngIf="chartOptions && !loading">
    <mat-icon class="reading-arrow">arrow_downward</mat-icon>
    <span>Reading Direction</span>
  </div>

  <div *ngIf="!loading" id="chartdiv" style="width: 100%; height: 300px;" class="mt-2"></div>

  <div *ngIf="chartErrorMsg && !loading" class="alert alert-danger mt-3">
    {{ chartErrorMsg }}
  </div>
</div>

<!-- Bloc erreur globale -->
<div *ngIf="errorMsg" class="alert alert-danger m-5 p-4 text-center">
  {{ errorMsg }}
</div>
